import { ArrowRight, Newspaper } from 'lucide-react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ChangelogCardFallback = () => {
  return (
    <Card className="bg-secondary p-0 gap-0">
      <CardHeader className="px-5 py-3 flex flex-row items-center justify-between gap-0">
        <CardTitle>
          <H3 className="flex items-center gap-2 text-sm text-muted-foreground">
            <Newspaper className="size-4" /> Changelog
          </H3>
        </CardTitle>
        <a
          href="https://docs.sevalla.com/changelog"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-sm text-primary underline-offset-4 hover:underline"
        >
          View all
          <ArrowRight className="size-3.5" />
        </a>
      </CardHeader>
      <CardContent className="p-0">
        <Card className="p-0 border-x-0 border-b-0 shadow-none">
          <CardContent className="p-4">
            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="h-24 w-full rounded-md" />
              ))}
            </div>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
